<template>
  <div class="category-banner-wrapper">
    <!-- Masaüstü: 3 slide -->
    <div class="banner-pc" v-if="!isMobileOrTablet">
      <div class="embla" ref="emblaPC">
        <div class="embla__container">
          <div
            v-for="(banner, index) in banners"
            :key="banner._id"
            class="embla__slide banner-card"
          >
            <img :src="backendUrl + banner.imageUrl" class="banner-image" />
          
          </div>
        </div>
      </div>
      <button class="embla__arrow embla__arrow--prev" @click="scrollPrevPC">&#60;</button>
      <button class="embla__arrow embla__arrow--next" @click="scrollNextPC">&#62;</button>

      <div class="progress-dots">
       <div
  v-for="(banner, index) in banners"
  :key="index"
  class="dot"
  :class="{
    active: index === selectedIndex,
    passed: index < selectedIndex
  }"
>
  <div
    v-if="index === selectedIndex"
    class="fill"
    :key="progressKey"
  ></div>
        </div>
      </div>
    </div>

    <!-- Mobil: 1 slide -->
    <div class="banner-mobile" v-else>
      <div class="embla" ref="emblaMobile">
        <div class="embla__container">
          <div
            v-for="(banner, index) in banners"
            :key="banner._id"
            class="embla__slide banner-card mobile-stacked"
          >
            <img :src="backendUrl + banner.imageUrl" class="banner-image" />
          
          </div>
        </div>
      </div>

      <div class="progress-dots">
        <div
          v-for="(banner, index) in banners"
          :key="index"
          class="dot"
          :class="{
  active: index === selectedIndexMobile,
  passed: index < selectedIndexMobile
}"
        >
          <div
            v-if="index === selectedIndexMobile"
            class="fill"
            :key="progressKeyMobile"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import axios from 'axios'
import emblaCarousel from 'embla-carousel'

const props = defineProps({
  slug: { type: String, required: true }
})

const banners = ref([])
const backendUrl = process.env.VUE_APP_BACKEND_URL || 'https://play.rivobit.com'

const isMobileOrTablet = ref(false)

const selectedIndex = ref(0)
const progressKey = ref(0)
const selectedIndexMobile = ref(0)
const progressKeyMobile = ref(0)

const emblaPC = ref(null)
const emblaMobile = ref(null)
let emblaInstancePC = null
let emblaInstanceMobile = null

const scrollNextPC = () => emblaInstancePC?.scrollNext()
const scrollPrevPC = () => emblaInstancePC?.scrollPrev()

let intervalPC = null
let intervalMobile = null

onMounted(async () => {
  isMobileOrTablet.value = window.innerWidth <= 1024

  try {
    const res = await axios.get(`/public/banners/${props.slug}`)
    banners.value = res.data || []
  } catch (err) {
    console.error('Banner fetch error:', err)
  }

  await nextTick()

  if (emblaPC.value) {
    emblaInstancePC = emblaCarousel(emblaPC.value, {
      loop: true,
      align: 'start',
      slidesToScroll: 1,
    })
    emblaInstancePC.on('select', () => {
      selectedIndex.value = emblaInstancePC.selectedScrollSnap()
      progressKey.value++
    })
  }

  if (emblaMobile.value) {
    emblaInstanceMobile = emblaCarousel(emblaMobile.value, {
      loop: true,
      align: 'center',
      slidesToScroll: 1,
    })
    emblaInstanceMobile.on('select', () => {
      selectedIndexMobile.value = emblaInstanceMobile.selectedScrollSnap()
      progressKeyMobile.value++
    })
  }

  intervalPC = setInterval(() => {
    if (!isMobileOrTablet.value && emblaInstancePC && banners.value.length > 1) {
      emblaInstancePC.scrollNext()
    }
  }, 5000)

  intervalMobile = setInterval(() => {
    if (isMobileOrTablet.value && emblaInstanceMobile && banners.value.length > 1) {
      emblaInstanceMobile.scrollNext()
    }
  }, 5000)
})

onUnmounted(() => {
  clearInterval(intervalPC)
  clearInterval(intervalMobile)
  emblaInstancePC?.destroy()
  emblaInstanceMobile?.destroy()
})
</script>

<style scoped>
/* Stil kısmını değiştirmedim, doğrudan senin verdiğin gibi kullanabilirsin. Aynı şekilde devam edebilir. */
.category-banner-wrapper {
  width: 100%;
  margin-bottom: 10px;
}
/* embla, embla__container, embla__slide, .banner-card vs. aynı kalabilir */
</style>


<style scoped>
.category-banner-wrapper {
  width: 100%;
  margin-bottom: 10px;
}
.embla {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.embla__container {
  display: flex;
  user-select: none;
}
.embla__slide {
  position: relative;
  flex: 0 0 33.3333%;
  min-width: 0;
  margin-right: 12px;
  border-radius: 10px;
  overflow: hidden;
  height: 220px;
  background: #191e26;
}
.banner-card {
  box-shadow: 0 3px 16px #0008;
  border-radius: 10px;
}
.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.banner-text {
  position: absolute;
  top: 16px;
  left: 16px;
  color: white;
  max-width: 70%;
  z-index: 2;
}
.text3d-lg {
  font-size: 1.4rem;
  font-weight: bold;
  text-shadow: 1px 1px 4px #000;
  margin: 0;
}
.text3d-sm {
  font-size: 1rem;
  font-weight: 600;
  text-shadow: 1px 1px 3px #000;
  margin-top: 6px;
}
.banner-button {
  display: inline-block;
  margin-top: 0.5rem;
  padding: 8px 14px;
  font-weight: 700;
  font-size: 0.9rem;
  color: white;
  text-decoration: none;
  border-radius: 5px;
  background: linear-gradient(to bottom, #01e0a3 0%, #00aa6d 95%);
  transition: transform 0.3s ease;
}
.banner-button:hover {
  transform: translateY(-2px);
}
.embla__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 3;
  background: none;
  border: none;
  font-size: 20px;
  color: #8899a8;
  cursor: pointer;
  transition: color 0.2s;
}
.embla__arrow--prev {
  left: -32px;
}
.embla__arrow--next {
  right: -32px;
}
.embla__arrow:hover {
  color: #fff;
}
.progress-dots {
  display: flex;
  justify-content: center;
  margin-top: 12px;
  gap: 6px;
}
.dot {
  width: 18px;
  height: 8px;
  background: var(--bar-outer);
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.dot.active {
  width: 38px;
  height: 8px;
  background: var(--bar-outer);
}

.dot.passed {
  background: var(--bar-inner);
}
.fill {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: var(--bar-inner);
  border-radius: 8px;
  animation: progressFill 5s linear forwards;
}
@keyframes progressFill {
  from { width: 0%; }
  to { width: 100%; }
}

/* Mobil özel: 1 slide ortalanmış, dotlar */
@media (max-width: 1024px) {
  .embla__slide {
    flex: 0 0 90%;
    margin-right: 8px;
    height: 140px;
  }
  .banner-card {
    height: 140px;
  }
}
</style>